import { render, staticRenderFns } from "./Group-Delete.vue?vue&type=template&id=6e039450&scoped=true&"
import script from "./Group-Delete.vue?vue&type=script&lang=js&"
export * from "./Group-Delete.vue?vue&type=script&lang=js&"
import style0 from "./Group-Delete.vue?vue&type=style&index=0&id=6e039450&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e039450",
  null
  
)

export default component.exports